<template>
  <div class="share-container">
    <div class="share-header">
      <div class="header-content">
        <button @click.stop="goBack" class="back-button">
          <span class="back-icon">←</span>
          <span>返回</span>
        </button>
        <div class="header-title">
          <div class="title-icon">🔁</div>
          <h1>视频分享</h1>
        </div>
      </div>
    </div>

    <div class="share-content">
      <div class="current-shop-section" v-if="advertiserName">
        <div class="shop-info-container">
          <div class="shop-icon">🏪</div>
          <div class="shop-details">
            <h3 class="shop-name">当前授权店铺</h3>
            <p class="shop-advertiser">{{ advertiserName }}</p>
          </div>
        </div>
      </div>

      <div class="form-card">
        <div class="form-title-row">
          <h2 class="form-title">待分享账户信息</h2>
          <button type="button" class="manual-input-toggle" @click="toggleManualInputMode">
            {{ isManualInputMode ? '关闭手动输入' : '手动输入' }}
          </button>
        </div>
        <div class="form-grid">
          <div class="input-group">
            <label for="old-advertiser-id">千川户ID</label>
            <input
              v-if="isManualInputMode"
              id="old-advertiser-id"
              v-model.trim="oldAdvertiserId"
              type="text"
              placeholder="请输入待分享千川户ID"
            />
            <el-select
              v-else
              id="old-advertiser-id"
              v-model="oldAdvertiserId"
              filterable
              placeholder="请选择待分享千川户"
              class="input-group-select"
              :disabled="advertiserLoading"
              :popper-append-to-body="true"
              @change="onOldAdvertiserChange"
            >
              <el-option v-for="item in advertiserOptions" :key="`old-${item.advertiserId}`" :label="item.name" :value="item.advertiserId" />
            </el-select>
          </div>
          <div class="input-group">
            <label for="old-ad-id">计划ID</label>
            <input
              v-if="isManualInputMode"
              id="old-ad-id"
              v-model.trim="oldAdId"
              type="text"
              placeholder="请输入待分享计划ID"
            />
            <el-select
              v-else
              id="old-ad-id"
              v-model="oldAdId"
              filterable
              placeholder="请选择待分享计划ID"
              class="input-group-select"
              :disabled="oldJobLoading || !oldAdvertiserId"
              :popper-append-to-body="true"
            >
              <el-option v-for="item in oldJobOptions" :key="`old-job-${item.id}`" :label="item.name" :value="item.id" />
            </el-select>
          </div>
          <div class="input-group full-width">
            <label>传输方式</label>
            <div class="mode-tabs">
              <button
                type="button"
                class="mode-tab"
                :class="{ active: transferMode === 'material_id' }"
                @click="transferMode = 'material_id'"
              >
                按素材ID传输
              </button>
              <button
                type="button"
                class="mode-tab"
                :class="{ active: transferMode === 'video_count' }"
                @click="transferMode = 'video_count'"
              >
                按视频数量传输
              </button>
              <button
                type="button"
                class="mode-tab"
                :class="{ active: transferMode === 'timer' }"
                @click="transferMode = 'timer'"
              >
                定时上报
              </button>
            </div>
          </div>
          <div v-if="transferMode === 'material_id'" class="input-group full-width">
            <label for="material-ids">素材ID</label>
            <textarea
              id="material-ids"
              v-model.trim="materialIds"
              rows="3"
              placeholder="请输入素材ID，多个素材ID请用英文逗号分割"
            />
          </div>
          <div v-else-if="transferMode === 'video_count'" class="input-group">
            <label for="video-count">视频数量</label>
            <input
              id="video-count"
              v-model.trim="videoCount"
              type="text"
              placeholder="请输入要传输的视频数量"
            />
          </div>
          <div v-else class="input-group">
            <label for="hour">调控时长（小时）</label>
            <input
              id="hour"
              v-model.trim="hour"
              type="text"
              placeholder="请输入调控小时数"
            />
          </div>
        </div>
      </div>

      <div class="form-card">
        <h2 class="form-title">接收户信息</h2>
        <div class="form-grid">
          <div class="input-group">
            <label for="advertiser-id">千川户ID</label>
            <el-select
              id="advertiser-id"
              v-model="advertiserId"
              filterable
              placeholder="请选择接收千川户"
              class="input-group-select"
              :disabled="advertiserLoading"
              :popper-append-to-body="true"
              @change="onReceiverAdvertiserChange"
            >
              <el-option v-for="item in advertiserOptions" :key="`receiver-${item.advertiserId}`" :label="item.name" :value="item.advertiserId" />
            </el-select>
          </div>
          <div class="input-group">
            <div class="input-group-label-row">
              <label for="ad-id">计划ID</label>
              <button type="button" class="mode-toggle-button" @click="toggleReceiverPlanInputMode">
                {{ manualReceiverPlanInput ? '切回选择' : '手动输入' }}
              </button>
            </div>
            <el-select
              v-if="!manualReceiverPlanInput"
              id="ad-id"
              v-model="adId"
              filterable
              placeholder="请选择接收计划ID"
              class="input-group-select"
              :disabled="receiverJobLoading || !advertiserId"
              :popper-append-to-body="true"
              @change="onReceiverPlanChange"
            >
              <el-option v-for="item in receiverJobOptions" :key="`receiver-job-${item.id}`" :label="item.name" :value="item.id" />
            </el-select>
            <input
              v-else
              id="ad-id"
              v-model.trim="adId"
              type="text"
              placeholder="请输入接收计划ID"
            />
          </div>
          <div class="input-group">
            <div class="input-group-label-row">
              <label for="product-id">商品ID</label>
              <button type="button" class="mode-toggle-button" @click="toggleReceiverProductInputMode">
                {{ manualReceiverProductInput ? '自动带出' : '手动输入' }}
              </button>
            </div>
            <input
              id="product-id"
              v-model="productId"
              type="text"
              :placeholder="manualReceiverProductInput ? '请输入接收商品ID' : '选择接收计划后自动带出'"
              :readonly="!manualReceiverProductInput"
            />
          </div>
        </div>
      </div>

      <div class="action-section">
        <button class="share-submit-button" @click="submitShare" :disabled="isSharing">
          <span v-if="isSharing" class="button-spinner"></span>
          <span>{{ isSharing ? sharingText : '分享视频' }}</span>
        </button>
      </div>

      <div v-if="statusMessage" class="status-message" :class="{ success: statusType === 'success', error: statusType === 'error' }">
        {{ statusMessage }}
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import API_CONFIG from '@/api/config'
import { createAdaptiveViewportMixin } from '@/mixins/adaptiveViewport'

export default {
  name: 'VideoShare',
  mixins: [createAdaptiveViewportMixin({ designWidth: 1440, designHeight: 920, minScale: 0.56, fitContentHeight: true })],
  data() {
    return {
      accessToken: '',
      advertiserName: '',
      username: '',
      advertiserOptions: [],
      advertiserLoading: false,
      oldAdvertiserId: '',
      oldAdId: '',
      oldJobOptions: [],
      oldJobLoading: false,
      isManualInputMode: false,
      transferMode: 'video_count',
      materialIds: '',
      videoCount: '500',
      hour: '',
      advertiserId: '',
      adId: '',
      receiverJobOptions: [],
      receiverJobLoading: false,
      manualReceiverPlanInput: false,
      manualReceiverProductInput: false,
      productId: '',
      isSharing: false,
      statusMessage: '',
      statusType: '',
      sharingDots: '',
      sharingTimer: null
    }
  },
  computed: {
    sharingText() {
      return `分享中${this.sharingDots}`
    }
  },
  created() {
    const query = this.$route.query
    this.accessToken = query.accessToken || localStorage.getItem('accessToken') || ''
    this.advertiserName = query.advertiserName || localStorage.getItem('advertiserName') || ''
    this.username = query.username || localStorage.getItem('username') || ''
    this.updatePageTitle()
    if (this.accessToken) {
      this.fetchAdvertiserOptions()
    }
  },
  methods: {
    updatePageTitle() {
      const name = String(this.advertiserName || '').trim()
      document.title = name ? `${name} - 视频分享` : '视频分享'
    },
    toggleManualInputMode() {
      this.isManualInputMode = !this.isManualInputMode
      if (this.isManualInputMode) {
        this.oldJobOptions = []
      } else if (this.oldAdvertiserId) {
        this.onOldAdvertiserChange()
      }
    },
    goBack() {
      this.$router.push('/home')
    },
    startSharingAnimation() {
      const dotStates = ['', '.', '..', '...']
      let index = 0
      this.sharingDots = dotStates[index]
      this.sharingTimer = setInterval(() => {
        index = (index + 1) % dotStates.length
        this.sharingDots = dotStates[index]
      }, 400)
    },
    stopSharingAnimation() {
      if (this.sharingTimer) {
        clearInterval(this.sharingTimer)
        this.sharingTimer = null
      }
      this.sharingDots = ''
    },
    async fetchAdvertiserOptions() {
      this.advertiserLoading = true
      try {
        const response = await axios.get(API_CONFIG.getFullUrl('/qianchuan/info/api/getShopAdvertiserPublicSimpleInfo'), {
          params: {
            accessToken: this.accessToken
          },
          headers: {
            username: this.username
          }
        })
        const list = response.data && response.data.code === 200 ? (response.data.data || []) : []
        this.advertiserOptions = list.map(item => ({
          name: item.id || '-',
          advertiserId: item.advertiser_id
        })).filter(item => item.advertiserId)
      } catch (error) {
        this.advertiserOptions = []
      } finally {
        this.advertiserLoading = false
      }
    },
    async fetchJobOptions(advertiserId) {
      if (!advertiserId) {
        return []
      }
      const response = await axios.get(API_CONFIG.uniPromotionJobListByTargetId(), {
        params: {
          targetId: advertiserId
        },
        headers: {
          username: this.username
        }
      })
      const list = response.data && response.data.code === 200 ? (response.data.data || []) : []
      return list.map(item => ({
        id: item.jobId,
        name: item.jobName || String(item.jobId || '-'),
        productId: item.productId
      })).filter(item => item.id)
    },
    async onOldAdvertiserChange() {
      this.oldAdId = ''
      this.oldJobOptions = []
      if (!this.oldAdvertiserId) {
        return
      }
      this.oldJobLoading = true
      try {
        this.oldJobOptions = await this.fetchJobOptions(this.oldAdvertiserId)
      } catch (error) {
        this.oldJobOptions = []
      } finally {
        this.oldJobLoading = false
      }
    },
    async onReceiverAdvertiserChange() {
      this.adId = ''
      this.productId = ''
      this.receiverJobOptions = []
      if (!this.advertiserId) {
        return
      }
      this.receiverJobLoading = true
      try {
        this.receiverJobOptions = await this.fetchJobOptions(this.advertiserId)
      } catch (error) {
        this.receiverJobOptions = []
      } finally {
        this.receiverJobLoading = false
      }
    },
    toggleReceiverPlanInputMode() {
      this.manualReceiverPlanInput = !this.manualReceiverPlanInput
      if (!this.manualReceiverPlanInput) {
        this.onReceiverPlanChange()
      }
    },
    toggleReceiverProductInputMode() {
      this.manualReceiverProductInput = !this.manualReceiverProductInput
      if (!this.manualReceiverProductInput) {
        this.onReceiverPlanChange()
      }
    },
    onReceiverPlanChange() {
      const selected = this.receiverJobOptions.find(item => String(item.id) === String(this.adId))
      if (!this.manualReceiverProductInput) {
        this.productId = selected ? selected.productId : ''
      }
    },
    async submitShare() {
      if (!this.accessToken) {
        this.statusType = 'error'
        this.statusMessage = '缺少access_token，请返回授权页重新进入'
        return
      }
      if (!this.oldAdvertiserId || !this.oldAdId || !this.advertiserId || !this.adId || !this.productId) {
        this.statusType = 'error'
        this.statusMessage = '请完整填写待分享账户和接收户信息'
        return
      }

      const numericPattern = /^\d+$/
      if (![this.oldAdvertiserId, this.oldAdId, this.advertiserId, this.adId, this.productId].every(value => numericPattern.test(value))) {
        this.statusType = 'error'
        this.statusMessage = '千川户ID、计划ID、商品ID必须为数字'
        return
      }

      const normalizedMaterialIds = this.materialIds
        .split(',')
        .map(item => item.trim())
        .filter(Boolean)

      if (this.transferMode === 'material_id') {
        if (!normalizedMaterialIds.length) {
          this.statusType = 'error'
          this.statusMessage = '按素材ID传输时，请填写至少一个素材ID'
          return
        }
        if (!normalizedMaterialIds.every(value => numericPattern.test(value))) {
          this.statusType = 'error'
          this.statusMessage = '素材ID必须为数字，多个素材ID请用英文逗号分割'
          return
        }
      } else if (this.transferMode === 'video_count') {
        if (!this.videoCount || !numericPattern.test(this.videoCount) || Number(this.videoCount) <= 0) {
          this.statusType = 'error'
          this.statusMessage = '按视频数量传输时，请填写大于0的数字'
          return
        }
      } else {
        if (!this.hour || !numericPattern.test(this.hour) || Number(this.hour) <= 0) {
          this.statusType = 'error'
          this.statusMessage = '定时上报时，请填写大于0的调控小时数'
          return
        }
      }

      this.isSharing = true
      this.statusMessage = ''
      this.statusType = ''
      this.startSharingAnimation()

      try {
        const payload = {
          access_token: this.accessToken,
          advertiser_id: this.advertiserId,
          ad_id: this.adId,
          old_advertiser_id: this.oldAdvertiserId,
          old_ad_id: this.oldAdId,
          product_id: this.productId,
          transfer_mode: this.transferMode,
          material_ids: this.transferMode === 'material_id' ? normalizedMaterialIds.join(',') : '',
          video_count: this.transferMode === 'video_count' || this.transferMode === 'timer' ? this.videoCount : '',
          hour: this.transferMode === 'timer' ? this.hour : ''
        }
        const requestUrl = this.transferMode === 'timer' ? API_CONFIG.materialShareTimer() : API_CONFIG.materialShare()
        const response = await axios.post(requestUrl, payload, {
          headers: {
            'Content-Type': 'application/json',
            username: this.username
          }
        })

        if (response.data && response.data.code === 200) {
          this.statusType = 'success'
          this.statusMessage = response.data.data || '视频分享成功'
          if (this.transferMode === 'timer') {
            alert(`调用成功，数量：${response.data.data}`)
          }
        } else {
          this.statusType = 'error'
          this.statusMessage = (response.data && (response.data.msg || response.data.message)) || '视频分享失败'
        }
      } catch (error) {
        this.statusType = 'error'
        this.statusMessage = error.response?.data?.msg || error.response?.data?.message || '视频分享请求失败'
      } finally {
        this.isSharing = false
        this.stopSharingAnimation()
      }
    }
  },
  beforeDestroy() {
    this.stopSharingAnimation()
  }
}
</script>

<style scoped>
.share-container {
  min-height: 100vh;
  height: 100vh;
  background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.share-header {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  padding: 14px 0;
}

.header-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  align-items: center;
  gap: 20px;
}

.back-button {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 25px;
  padding: 10px 20px;
  color: white;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
}

.back-button:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: translateX(-5px);
}

.header-title {
  display: flex;
  align-items: center;
  gap: 10px;
}

.title-icon {
  font-size: 24px;
}

.header-title h1 {
  color: white;
  font-size: 24px;
  font-weight: 600;
  margin: 0;
}

.share-content {
  flex: 1;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 16px 16px 18px;
  overflow: hidden;
  min-height: 0;
  box-sizing: border-box;
}

.current-shop-section {
  margin-bottom: 20px;
}

.shop-info-container {
  background: rgba(255, 255, 255, 0.12);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  padding: 18px 20px;
  display: flex;
  align-items: center;
  gap: 12px;
}

.shop-icon {
  font-size: 24px;
}

.shop-details h3,
.shop-details p {
  margin: 0;
}

.shop-name {
  color: rgba(255, 255, 255, 0.8);
  font-size: 14px;
  font-weight: 500;
}

.shop-advertiser {
  color: white;
  font-size: 18px;
  font-weight: 600;
  margin-top: 4px;
}

.form-card {
  background: rgba(255, 255, 255, 0.12);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 15px;
  padding: 18px;
  margin-bottom: 14px;
}

.form-title {
  margin: 0 0 18px;
  color: white;
  font-size: 20px;
}

.form-title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 18px;
}

.form-title-row .form-title {
  margin: 0;
}

.manual-input-toggle {
  border: 1px solid rgba(255, 255, 255, 0.35);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
  padding: 6px 12px;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.manual-input-toggle:hover {
  background: rgba(255, 255, 255, 0.2);
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 16px;
}

.input-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.input-group-label-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.input-group label {
  color: rgba(255, 255, 255, 0.85);
  font-size: 14px;
}

.mode-toggle-button {
  border: 1px solid rgba(255, 255, 255, 0.35);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
  padding: 6px 12px;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.mode-toggle-button:hover {
  background: rgba(255, 255, 255, 0.2);
}

.input-group input {
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 10px;
  color: white;
  font-size: 14px;
  padding: 12px 14px;
  outline: none;
  transition: all 0.3s ease;
}

.input-group-select {
  width: 100%;
}

.input-group textarea {
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 10px;
  color: white;
  font-size: 14px;
  padding: 12px 14px;
  outline: none;
  transition: all 0.3s ease;
  resize: vertical;
  min-height: 88px;
}

.input-group input::placeholder {
  color: rgba(255, 255, 255, 0.55);
}

.input-group textarea::placeholder {
  color: rgba(255, 255, 255, 0.55);
}

.input-group input:focus {
  border-color: #00d4ff;
  box-shadow: 0 0 0 2px rgba(0, 212, 255, 0.18);
}

.input-group input[readonly] {
  background: rgba(255, 255, 255, 0.08);
  color: rgba(255, 255, 255, 0.8);
  cursor: default;
}

::v-deep .input-group-select .el-input__inner {
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 10px;
  color: white;
  font-size: 14px;
  height: 44px;
  line-height: 44px;
}

::v-deep .input-group-select .el-input__suffix-inner i {
  color: rgba(255, 255, 255, 0.75);
}

::v-deep .input-group-select.is-disabled .el-input__inner {
  background: rgba(255, 255, 255, 0.08);
  color: rgba(255, 255, 255, 0.55);
}

::v-deep .el-select-dropdown__item {
  color: #1f2a44;
}

.input-group textarea:focus {
  border-color: #00d4ff;
  box-shadow: 0 0 0 2px rgba(0, 212, 255, 0.18);
}

.mode-tabs {
  display: flex;
  gap: 10px;
}

.mode-tab {
  border: 1px solid rgba(255, 255, 255, 0.35);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.8);
  padding: 8px 14px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.mode-tab.active {
  border-color: #00d4ff;
  background: rgba(0, 212, 255, 0.2);
  color: #ffffff;
}
.full-width {
  grid-column: 1 / -1;
}

.action-section {
  margin-top: 10px;
}

.share-submit-button {
  width: 100%;
  border: none;
  border-radius: 25px;
  background: linear-gradient(45deg, #26c6da, #00acc1);
  color: white;
  font-size: 16px;
  font-weight: 600;
  padding: 14px 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.share-submit-button:disabled {
  opacity: 0.8;
  cursor: not-allowed;
}

.share-submit-button:not(:disabled):hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 18px rgba(38, 198, 218, 0.35);
}

.button-spinner {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.35);
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

.status-message {
  margin-top: 16px;
  border-radius: 10px;
  padding: 12px 14px;
  font-size: 14px;
}

.status-message.success {
  background: rgba(46, 213, 115, 0.2);
  border: 1px solid rgba(46, 213, 115, 0.4);
  color: #7dffb8;
}

.status-message.error {
  background: rgba(255, 107, 107, 0.2);
  border: 1px solid rgba(255, 107, 107, 0.4);
  color: #ff9f9f;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

@media (max-width: 768px) {
  .share-container {
    min-height: 100vh;
    height: auto;
    overflow-y: auto;
  }

  .share-content {
    padding: 12px 10px 16px;
    overflow: visible;
  }

  .header-content {
    padding: 0 12px;
    gap: 12px;
    flex-wrap: wrap;
  }

  .back-button {
    padding: 8px 14px;
    font-size: 13px;
  }

  .header-title h1 {
    font-size: 20px;
  }

  .shop-info-container,
  .form-card {
    border-radius: 12px;
  }

  .shop-info-container {
    padding: 14px 16px;
  }

  .form-card {
    padding: 14px;
  }

  .form-title-row {
    align-items: flex-start;
    flex-direction: column;
  }

  .form-title {
    font-size: 18px;
  }

  .form-grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .mode-tabs {
    flex-wrap: wrap;
  }

  .mode-tab {
    flex: 1 1 calc(50% - 10px);
    text-align: center;
  }

  .share-submit-button {
    border-radius: 14px;
    padding: 12px 16px;
    font-size: 15px;
  }
}

@media (max-width: 480px) {
  .share-header {
    padding: 10px 0;
  }

  .header-content {
    padding: 0 10px;
    gap: 10px;
  }

  .back-button {
    padding: 6px 10px;
    font-size: 12px;
  }

  .header-title {
    gap: 8px;
  }

  .title-icon {
    font-size: 20px;
  }

  .header-title h1 {
    font-size: 18px;
  }

  .shop-info-container {
    align-items: flex-start;
    padding: 12px 14px;
  }

  .shop-name {
    font-size: 13px;
  }

  .shop-advertiser {
    font-size: 16px;
  }

  .form-card {
    padding: 12px;
  }

  .form-title {
    font-size: 16px;
  }

  .input-group input,
  .input-group textarea {
    padding: 10px 12px;
    font-size: 13px;
  }

  .mode-tab {
    flex-basis: 100%;
    font-size: 12px;
    padding: 8px 12px;
  }

  .share-submit-button {
    font-size: 14px;
  }
}
</style>
